import React, { ChangeEvent, Component } from "react";
import PropTypes from "prop-types";
import ICommission_Tiers from "../../../../../models/ICommission_Tiers";
import OwInputWrapper from "../../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import OwTranslate from "../../../../shared/OwTranslate/OwTranslate";

type Props = {
    tier: ICommission_Tiers;
    index: number;
    updateTierDataFn: (tier: ICommission_Tiers, index: number) => void;
};

type State = {
    editMode: boolean;
    tier: ICommission_Tiers;
};

class CommissionTierRow extends Component<Props, State> {
    readonly state: State = {
        editMode: false,
        tier: { ...this.props.tier },
    };

    componentDidMount(): void {
        if (!this.props.tier.guid) {
            this.setState({
                editMode: true,
            });
        }
    }

    toggleEditMode = () => {
        this.setState(
            {
                editMode: !this.state.editMode,
            },
            () => {
                if (!this.state.editMode) {
                    this.props.updateTierDataFn(this.state.tier, this.props.index);
                }
            }
        );
    };

    handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const tier = this.state.tier;

        // @ts-expect-error
        tier[name] = value;

        // console.log('tier: ', tier);

        this.setState({ tier });
    };

    cancel = () => {
        console.log("cancel: ", this.props.tier);
        this.setState({
            tier: { ...this.props.tier },
            editMode: false,
        });
    };

    render() {
        return (
            <div className="CommissionTierRow">
                {this.state.editMode ? (
                    <div className={"d-inline-flex align-items-center"}>
                        <span className={"text-success me-3 pointer"} onClick={this.toggleEditMode}>
                            <i className={"fas fa-check me-1"}></i> <OwTranslate defaultMessage={"confirm"} id={"confirm"} />
                        </span>
                        <span className={"text-danger pointer"} onClick={this.cancel}>
                            <i className={"fas fa-times me-1"}></i> <OwTranslate defaultMessage={"cancel"} id={"cancel"} />
                        </span>
                    </div>
                ) : (
                    <div>
                        <span className={"text-primary pointer"} onClick={this.toggleEditMode}>
                            <i className={"fas fa-pencil me-1"}></i> <OwTranslate defaultMessage={"edit"} id={"edit"} />
                        </span>
                    </div>
                )}
                <table className={"table table-dark"}>
                    <thead>
                        <tr>
                            <th>
                                <OwLabel title={"percent"} />
                            </th>
                            <th>
                                <OwLabel title={"min_amount"} />
                            </th>
                            <th>
                                <OwLabel title={"max_amount"} />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <OwInputWrapper
                                    type={"number"}
                                    name={"percent"}
                                    fn={this.handleChange}
                                    value={this.state.tier.percent}
                                    editMode={this.state.editMode}
                                />
                            </td>
                            <td>
                                <OwInputWrapper
                                    type={"number"}
                                    name={"min_amount"}
                                    fn={this.handleChange}
                                    value={this.state.tier.min_amount}
                                    editMode={this.state.editMode}
                                />
                            </td>
                            <td>
                                <OwInputWrapper
                                    type={"number"}
                                    name={"max_amount"}
                                    fn={this.handleChange}
                                    value={this.state.tier.max_amount}
                                    editMode={this.state.editMode}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default CommissionTierRow;
